import { useCallback, ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  PaymentFrequency,
  paymentFrequencyGuard,
} from "@evergiving/common/dist/es2015/pledge";
import { PaymentFrequenciesConfig } from "@evergiving/common/dist/es2015/form";
import { notNil } from "@evergiving/common/dist/es2015/typescriptUtils";

import { RootState } from "../redux/types";
import { setPaymentFrequency } from "../redux/actions";
import { RadioGroup, RadioOptionSpec } from "./RadioGroup";

export function PaymentFrequencyOptions({
  frequencies,
}: {
  frequencies: PaymentFrequenciesConfig;
}): ReactElement {
  const paymentFrequency = useSelector(
    (state: RootState) => state.paymentFrequency
  );
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (newValue: PaymentFrequency) => {
      dispatch(setPaymentFrequency(newValue));
    },
    [dispatch]
  );

  const options: RadioOptionSpec<PaymentFrequency>[] = Object.keys(frequencies)
    .filter(paymentFrequencyGuard)
    .map((value) => {
      const frequency = frequencies[value];
      if (frequency === undefined) return undefined;
      const { optionText } = frequency;
      return {
        value,
        content: function PaymentFrequencyOptionContent() {
          return <div>{optionText}</div>;
        },
      };
    })
    .filter(notNil);

  return (
    <RadioGroup
      value={paymentFrequency}
      onChange={handleChange}
      ariaLabel="Donation Frequency"
      ariaRequired
      autoFocus
    >
      {options}
    </RadioGroup>
  );
}

// .filter(paymentFrequencyGuard)
